import rules from "../rules/manufacture_rules.json";
import { ProductDraft, ManufactureEstimate, ManufactureStep } from "../types";
import { getLearnedMinutes } from "../learning/timeLearner";

function bucketForDiameter(type: string, d: number) {
  const rs: any = (rules as any)[type];
  if (!rs) return null;
  return rs.sizeBuckets.find((b: any) => d <= b.maxDiameter) || rs.sizeBuckets.at(-1);
}

export function estimateManufacture(
  draft: ProductDraft,
  method: string = "Wheel Throwing",
  handle = false,
  glazeLayers = 1
): ManufactureEstimate {
  const diam = draft.dimensions.diameterMmTop;
  const rs: any = (rules as any)[draft.type];
  const b = bucketForDiameter(draft.type, diam);
  if (!rs || !b) return { steps: [], totalMinutes: 0, firing: {}, confidence: 0.4 };

  const mod = rs.methodModifiers?.[method] ?? 0;
  const learnedThrow = getLearnedMinutes(draft.type, "throw");
  const learnedTrim  = getLearnedMinutes(draft.type, "trim");
  const learnedGlaze = getLearnedMinutes(draft.type, "glaze");
  const learnedHandle= getLearnedMinutes(draft.type, "attach_handle");

  const steps: ManufactureStep[] = [];
  const throwMin = Math.max(2, Math.round((learnedThrow ?? (b.throwMin * (1 + mod)))));
  const trimMin  = Math.max(1, Math.round((learnedTrim  ?? (b.trimMin  * (1 + mod)))));
  const glazeMin = Math.max(1, Math.round((learnedGlaze ?? b.glazeMin) * glazeLayers));
  const handleMin= learnedHandle ?? (b.handleMin ?? 0);

  steps.push({ key: "throw", minutes: throwMin });
  steps.push({ key: "trim", minutes: trimMin });
  if (handle) steps.push({ key: "attach_handle", minutes: Math.round(handleMin) });
  steps.push({ key: "glaze", minutes: glazeMin });

  const volFactor = Math.min(1.6, Math.max(0.7, diam / 100));
  const firing = { bisqueHours: Math.round(36 * volFactor), glazeHours: Math.round(30 * volFactor) };

  const totalMinutes = steps.reduce((a, s) => a + s.minutes, 0);
  const learnedCount = [learnedThrow, learnedTrim, learnedGlaze, handle ? learnedHandle : null].filter(v => typeof v === "number").length;
  const confidence = 0.6 + Math.min(0.4, learnedCount * 0.1);

  return { steps, totalMinutes, firing, confidence };
}
